import React, {Component} from 'react';
import {Link} from 'react-router';
import {connect} from 'react-redux';
import {message, Table} from 'antd';

import moment from 'moment';
import {queryCustomCanMoveOut, queryCustomMoveOut, queryCustomMoveOutRemind} from '@api/incubator/custom';
import {setWbTabCurrent} from '@store/modules/incubator/wb_tab_current';

import ModalOut from './ModalOut';

class TableCustom extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: {
        list: [],
        pagination: {},
      },
    };
  }

  componentWillMount() {}

  componentDidMount() {
    const { currentShow } = this.props;
    this.incuUuid = this.props.incuUuid;
    this.current = currentShow.custom45Page || 1;
    this.getCustomMoveOutRemind();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.incuUuid !== this.incuUuid) {
      this.incuUuid = nextProps.incuUuid;
      this.props.incuUuid && (this.current = 1);
      this.getCustomMoveOutRemind();
    }
  }

  getCustomMoveOutRemind = () => {
    if (!this.incuUuid) {
      return;
    }
    const { pageSize } = this.props;
    queryCustomMoveOutRemind({
      incubatorUuid: this.incuUuid || '',
      start: this.current || 1,
      limit: pageSize,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          dataSource: {
            list: res.data,
            pagination: {
              total: res.totalSize,
              pageSize,
              current: this.current,
            },
          },
        });
      }
    });
  };

  // 标签
  getTags = tags => {
    return tags.reduce((prev, curr) => `${prev + curr.name}、`, '');
  };

  // 点击迁出
  handleClickOut = record => {
    const incubatorUuid = this.incuUuid;
    queryCustomCanMoveOut({
      incubatorUuid,
      customUuid: record.customUuid,
    }).then(res => {
      if (res.statusCode === 200) {
        const { isMoveOut, isArchived } = res.data;
        !isMoveOut && !isArchived && message.error('暂时无法迁出，合同未归档，地址未迁出');
        isMoveOut && !isArchived && message.error('暂时无法迁出，合同未归档');
        !isMoveOut && isArchived && message.error('暂时无法迁出，地址未迁出');
        isMoveOut && isArchived && this.handleResonVisible(true, record);
      } else {
        message.error(res.message);
      }
    });
  };

  // 迁出弹框
  handleResonVisible = (flag, current) => {
    this.setState({
      resonVisible: !!flag,
    });
    this.currentCustom = current || {};
  };

  confirm = params => {
    queryCustomMoveOut({
      uuid: this.currentCustom.uuid,
      ...params,
    }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.handleResonVisible(false);
        this.getCustomMoveOutRemind();
      } else {
        message.error(res.message);
      }
    });
  };

  handleTableChange = (pagination, filters, sorter) => {
    this.current = pagination.current;
    this.getCustomMoveOutRemind();
    const { currentShow } = this.props;
    currentShow.custom45Page = pagination.current;
    this.props.dispatch(setWbTabCurrent(currentShow));
  };

  columns = () => {
    return [
      {
        title: '公司名称',
        dataIndex: 'customName',
        key: 'customName',
        render: (text, record) => (
          <Link to={`/incubator/${this.incuUuid}/custom/detail/${record.customUuid}`}>{text}</Link>
        ),
      },
      {
        title: '联系人',
        dataIndex: 'contactName',
        key: 'contactName',
      },
      {
        title: '联系方式',
        dataIndex: 'contactTel',
        key: 'contactTel',
      },
      {
        title: '标签',
        dataIndex: 'tags',
        key: 'tags',
        render: (text, record) => <span>{() => this.getTags(record.tags)}</span>,
      },
      {
        title: '是否获得融资',
        dataIndex: 'isFinancing',
        key: 'isFinancing',
        render: text => {
          let string;
          if (text === 0) {
            string = '否';
          } else if (text === 1) {
            string = '是';
          } else {
            string = '';
          }
          return <span>{string}</span>;
        },
      },
      {
        title: '开始入驻时间',
        dataIndex: 'beginDate',
        key: 'beginDate',
        render: (text, record) => (
          <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>
        ),
      },
      {
        title: '合同到期时间',
        dataIndex: 'endDate',
        key: 'endDate',
        render: (text, record) => {
          let day = 0;
          if (text) {
            day = Math.floor((Date.now() - text) / 86400000);
          }

          const element =
            day > 0 ? (
              <p style={{ color: 'red', marginBottom: '0' }}>（逾期{day}天）</p>
            ) : (
              <p style={{ marginBottom: '0' }}>（剩余{Math.abs(day)}天）</p>
            );
          return (
            <span>
              {text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}
              {day ? element : ''}
            </span>
          );
        },
      },
      {
        title: '操作',
        dataIndex: 'isMoveOut',
        render: (text, record) => <a onClick={() => this.handleClickOut(record)}>迁出</a>,
      },
    ];
  };

  render() {
    const {
      dataSource: { list, pagination },
      resonVisible,
    } = this.state;
    return (
      <div>
        <Table
          columns={this.columns()}
          dataSource={list}
          pagination={pagination}
          onChange={this.handleTableChange}
        />
        <ModalOut
          visible={resonVisible}
          handleOk={this.confirm}
          handleCancel={this.handleResonVisible}
        />
      </div>
    );
  }
}

export default connect(state => ({ currentShow: state.wb_tab_current }))(TableCustom);



// WEBPACK FOOTER //
// ./src/components/incubator/workbench/custom/Table45.js